import GetEnterpriseResponseDto from '@enterprise/models/dto/enterprise-get.dto.';
import EstablishmentMutationPayload from '@establishment/models/dto/establishment-mutation.dto';
import getEstablishmentResponseDto from '@establishment/models/dto/get-establishment.response.dto';
import { modeType } from '@models/mode';
import IOption from '@models/option';
import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useEffect,
  useState,
} from 'react';

interface EstablishmentMutationContextData {
  stepIndex: number;
  setStepIndex: Dispatch<SetStateAction<number>>;
  payload: EstablishmentMutationPayload | undefined;
  setPayload: Dispatch<
    SetStateAction<EstablishmentMutationPayload | undefined>
  >;
  sectors: IOption[] | undefined;
  setSectors: Dispatch<SetStateAction<IOption[] | undefined>>;
  enterprise: GetEnterpriseResponseDto | undefined;
  setEnterprise: Dispatch<SetStateAction<GetEnterpriseResponseDto | undefined>>;
  mode: modeType;
  setMode: Dispatch<SetStateAction<modeType>>;
  isDirty: boolean;
  setIsDirty: Dispatch<SetStateAction<boolean>>;
  establishment: getEstablishmentResponseDto | undefined;
  setEstablishment: Dispatch<
    SetStateAction<getEstablishmentResponseDto | undefined>
  >;
}

export const EstablishmentMutationContext = createContext<
  EstablishmentMutationContextData | undefined
>(undefined);

const EstablishmentMutationProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [stepIndex, setStepIndex] = useState<number>(0);
  const [payload, setPayload] = useState<EstablishmentMutationPayload>();
  const [mode, setMode] = useState<'create' | 'edit' | undefined>('create');
  const [isDirty, setIsDirty] = useState<boolean>(false);

  // only for UI
  const [sectors, setSectors] = useState<IOption[] | undefined>([]);
  const [establishment, setEstablishment] = useState<
    getEstablishmentResponseDto | undefined
  >();
  const [enterprise, setEnterprise] = useState<
    GetEnterpriseResponseDto | undefined
  >(undefined);

  useEffect(() => {
    if (
      payload?.addressDto?.cityId === '' ||
      payload?.addressDto?.cityId === undefined
    ) {
      setPayload((prevPayload) => {
        const updatedPayload = { ...prevPayload };
        if (updatedPayload.addressDto) {
          delete updatedPayload.addressDto.cityId;
        }
        return updatedPayload;
      });
    }
  }, [payload?.addressDto]);

  return (
    <EstablishmentMutationContext.Provider
      value={{
        stepIndex,
        setStepIndex,
        payload,
        setPayload,
        sectors,
        setSectors,
        mode,
        setMode,
        enterprise,
        setEnterprise,
        isDirty,
        setIsDirty,
        establishment,
        setEstablishment,
      }}
    >
      {children}
    </EstablishmentMutationContext.Provider>
  );
};

export default EstablishmentMutationProvider;
